const LS_newsletter_popup = 'dawei_newsletter_popup';
const SHOW_EACH = /*24 *  */ 60 * 60 * 1000;
const SHOW_DELAY = 5 * 1000;


const onClick = e => {

  e && e.preventDefault();
  e && e.stopImmediatePropagation();
  const popup = document.querySelector("#newsletter-popup");
  popup && popup.classList.toggle("open");
  localStorage.setItem(LS_newsletter_popup,Date.now());
  
};

export const cleanPopup = () => {
  const openers = document.querySelectorAll(".open-popup-newsletter");
  openers.forEach(o => {
    o.removeEventListener("click", onClick);
  });
};

export const initPopup = () => {

  const popupColumns = document.querySelector("#newsletter-popup .wp-block-columns");
  const popup = document.querySelector("#newsletter-popup");

  if(!popup){
    return
  }

 
  const openers = document.querySelectorAll(".open-popup-newsletter");

  openers.forEach(o => {
    o.addEventListener("click", onClick);
  });


  let closer = document.querySelector("i.close-popup-newsletter");
  if (!closer) {
    closer = document.createElement("i");
    closer.classList.add("close-popup-newsletter");
    popupColumns && popupColumns.append(closer);
  }
  closer.addEventListener("click", onClick);

  let overlay = document.querySelector("div.popup-newsletter-overlay");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.classList.add("popup-newsletter-overlay");
    popup && popup.append(overlay);
  }
  overlay.addEventListener("click", onClick);


  const lastOpenPopup =  localStorage.getItem(LS_newsletter_popup);
  const shouldAutoOpen = +lastOpenPopup + SHOW_EACH - Date.now() < 0;
  shouldAutoOpen && setTimeout(onClick,SHOW_DELAY);

};
